import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'

function TermsOfService() {
  return (
    <div className="py-12">
      <div className="container mx-auto px-4 max-w-4xl">
        <h1 className="text-4xl font-bold text-center mb-8">Terms of Service</h1>
        
        <Card>
          <CardHeader>
            <CardTitle>Terms of Service for Hill Bros Brighton Ltd</CardTitle>
            <p className="text-sm text-muted-foreground">Last updated: {new Date().toLocaleDateString()}</p>
          </CardHeader>
          <CardContent className="prose prose-gray max-w-none">
            <section className="mb-6">
              <h2 className="text-xl font-semibold mb-3">1. Agreement to Terms</h2>
              <p className="mb-3">
                By accessing and using the website www.hill-bros.co.uk ("Website") and services of Hill Bros Brighton Ltd (Company Registration Number: [To be added], "Company", "we", "us", or "our"), you agree to be bound by these Terms of Service ("Terms"). If you disagree with any part of these terms, you do not have permission to access our services.
              </p>
            </section>

            <section className="mb-6">
              <h2 className="text-xl font-semibold mb-3">2. Our Services</h2>
              <p className="mb-3">
                Hill Bros Brighton Ltd provides roofing, building, and property maintenance services including but not limited to:
              </p>
              <ul className="list-disc pl-6 mb-3">
                <li>Roofing and flat roofing installation and repairs</li>
                <li>General building and construction work</li>
                <li>Property maintenance and repairs</li>
                <li>Drone roof surveys and inspections</li>
                <li>Specialist services as advertised on our website</li>
              </ul>
            </section>

            <section className="mb-6">
              <h2 className="text-xl font-semibold mb-3">3. Quotations and Pricing</h2>
              <h3 className="text-lg font-medium mb-2">3.1 Quotations</h3>
              <ul className="list-disc pl-6 mb-3">
                <li>All quotations are valid for 30 days from the date of issue unless otherwise stated</li>
                <li>Quotations are based on the scope of work specified and site conditions at the time of survey</li>
                <li>Additional work discovered during the project will be quoted separately</li>
                <li>Prices quoted exclude VAT unless specifically stated</li>
              </ul>

              <h3 className="text-lg font-medium mb-2">3.2 Price Changes</h3>
              <p className="mb-3">
                We reserve the right to adjust prices if:
              </p>
              <ul className="list-disc pl-6 mb-3">
                <li>The scope of work changes from the original specification</li>
                <li>Unforeseen circumstances or hidden defects are discovered</li>
                <li>There are significant changes in material costs (with prior notice)</li>
              </ul>
            </section>

            <section className="mb-6">
              <h2 className="text-xl font-semibold mb-3">4. Payment Terms</h2>
              <ul className="list-disc pl-6 mb-3">
                <li>Payment terms will be specified in each quotation</li>
                <li>For larger projects, staged payments may be required</li>
                <li>Final payment is due upon completion unless otherwise agreed</li>
                <li>We accept payment by bank transfer, cheque, or card</li>
                <li>Late payments may incur interest at 8% above the Bank of England base rate</li>
              </ul>
            </section>

            <section className="mb-6">
              <h2 className="text-xl font-semibold mb-3">5. Work Commencement and Completion</h2>
              <h3 className="text-lg font-medium mb-2">5.1 Scheduling</h3>
              <ul className="list-disc pl-6 mb-3">
                <li>Start dates are subject to weather conditions and material availability</li>
                <li>We will notify you of any delays as soon as reasonably possible</li>
                <li>Completion times are estimates and not guaranteed</li>
              </ul>

              <h3 className="text-lg font-medium mb-2">5.2 Access Requirements</h3>
              <p className="mb-3">
                The customer must provide:
              </p>
              <ul className="list-disc pl-6 mb-3">
                <li>Safe and adequate access to the work area</li>
                <li>Clearance of personal items from work areas</li>
                <li>Parking arrangements where necessary</li>
                <li>Access to electricity and water supplies if required</li>
              </ul>
            </section>

            <section className="mb-6">
              <h2 className="text-xl font-semibold mb-3">6. Warranties and Guarantees</h2>
              <h3 className="text-lg font-medium mb-2">6.1 Workmanship Guarantee</h3>
              <p className="mb-3">
                We provide a guarantee on our workmanship as follows:
              </p>
              <ul className="list-disc pl-6 mb-3">
                <li>Roofing work: 10-year guarantee (subject to terms)</li>
                <li>General building work: 5-year guarantee</li>
                <li>Minor repairs: 12-month guarantee</li>
              </ul>

              <h3 className="text-lg font-medium mb-2">6.2 Material Warranties</h3>
              <p className="mb-3">
                Material warranties are provided by manufacturers and passed on to customers where applicable. These are separate from our workmanship guarantee.
              </p>

              <h3 className="text-lg font-medium mb-2">6.3 Exclusions</h3>
              <p className="mb-3">Our guarantee does not cover:</p>
              <ul className="list-disc pl-6 mb-3">
                <li>Damage caused by extreme weather events or acts of God</li>
                <li>Normal wear and tear</li>
                <li>Damage caused by third parties or customer negligence</li>
                <li>Work or modifications carried out by others</li>
              </ul>
            </section>

            <section className="mb-6">
              <h2 className="text-xl font-semibold mb-3">7. Cancellation Policy</h2>
              <h3 className="text-lg font-medium mb-2">7.1 Customer Cancellation</h3>
              <ul className="list-disc pl-6 mb-3">
                <li>Orders can be cancelled without charge up to 48 hours before the scheduled start date</li>
                <li>Cancellations within 48 hours may incur charges for materials already ordered</li>
                <li>Bespoke or special order materials are non-refundable</li>
              </ul>

              <h3 className="text-lg font-medium mb-2">7.2 Our Right to Cancel</h3>
              <p className="mb-3">
                We reserve the right to cancel or postpone work due to:
              </p>
              <ul className="list-disc pl-6 mb-3">
                <li>Adverse weather conditions</li>
                <li>Health and safety concerns</li>
                <li>Non-payment of agreed deposits</li>
                <li>Failure to provide agreed access</li>
              </ul>
            </section>

            <section className="mb-6">
              <h2 className="text-xl font-semibold mb-3">8. Health and Safety</h2>
              <p className="mb-3">
                We are committed to maintaining the highest standards of health and safety:
              </p>
              <ul className="list-disc pl-6 mb-3">
                <li>All work is carried out in accordance with current health and safety regulations</li>
                <li>We maintain comprehensive public liability and employer's liability insurance</li>
                <li>Risk assessments are conducted for all projects</li>
                <li>Customers must inform us of any known hazards on the property</li>
              </ul>
            </section>

            <section className="mb-6">
              <h2 className="text-xl font-semibold mb-3">9. Liability and Insurance</h2>
              <h3 className="text-lg font-medium mb-2">9.1 Insurance Coverage</h3>
              <p className="mb-3">
                We maintain:
              </p>
              <ul className="list-disc pl-6 mb-3">
                <li>Public Liability Insurance: £5,000,000</li>
                <li>Employer's Liability Insurance: £10,000,000</li>
                <li>Professional Indemnity Insurance where applicable</li>
              </ul>

              <h3 className="text-lg font-medium mb-2">9.2 Limitation of Liability</h3>
              <p className="mb-3">
                Our liability is limited to:
              </p>
              <ul className="list-disc pl-6 mb-3">
                <li>The value of the work contracted</li>
                <li>Direct damages only (not consequential losses)</li>
                <li>Rectification of defective work under our guarantee</li>
              </ul>
            </section>

            <section className="mb-6">
              <h2 className="text-xl font-semibold mb-3">10. Complaints Procedure</h2>
              <p className="mb-3">
                We aim to resolve all complaints promptly and fairly:
              </p>
              <ol className="list-decimal pl-6 mb-3">
                <li>Initial complaints should be made to our office within 7 days of issue arising</li>
                <li>We will acknowledge complaints within 2 working days</li>
                <li>We aim to resolve complaints within 14 days</li>
                <li>If unresolved, complaints may be escalated to relevant trade associations</li>
              </ol>
            </section>

            <section className="mb-6">
              <h2 className="text-xl font-semibold mb-3">11. Intellectual Property</h2>
              <p className="mb-3">
                All content on our website including text, images, logos, and designs are the property of Hill Bros Brighton Ltd or used with permission. Unauthorized use is prohibited.
              </p>
            </section>

            <section className="mb-6">
              <h2 className="text-xl font-semibold mb-3">12. Website Use</h2>
              <p className="mb-3">When using our website, you agree not to:</p>
              <ul className="list-disc pl-6 mb-3">
                <li>Use the site for any unlawful purpose</li>
                <li>Attempt to gain unauthorized access to our systems</li>
                <li>Transmit any malicious code or viruses</li>
                <li>Copy or reproduce content without permission</li>
                <li>Use automated systems to access the site without permission</li>
              </ul>
            </section>

            <section className="mb-6">
              <h2 className="text-xl font-semibold mb-3">13. Governing Law</h2>
              <p className="mb-3">
                These Terms are governed by the laws of England and Wales. Any disputes will be subject to the exclusive jurisdiction of the courts of England and Wales.
              </p>
            </section>

            <section className="mb-6">
              <h2 className="text-xl font-semibold mb-3">14. Changes to Terms</h2>
              <p className="mb-3">
                We reserve the right to update these Terms at any time. Changes will be posted on this page with an updated revision date. Continued use of our services after changes constitutes acceptance of the new Terms.
              </p>
            </section>

            <section className="mb-6">
              <h2 className="text-xl font-semibold mb-3">15. Contact Information</h2>
              <div className="bg-gray-50 p-4 rounded-lg">
                <p className="font-semibold">Hill Bros Brighton Ltd</p>
                <p>31 Connaught Road</p>
                <p>Seaford, BN25 2PU</p>
                <p>Email: info@hill-bros.co.uk</p>
                <p>Phone: 01273 326200</p>
              </div>
            </section>

            <section className="mb-6">
              <h2 className="text-xl font-semibold mb-3">16. Trading Standards</h2>
              <p className="mb-3">
                For consumer advice and to report problems, contact:
              </p>
              <div className="bg-gray-50 p-4 rounded-lg">
                <p>Citizens Advice Consumer Helpline: 0808 223 1133</p>
                <p>Trading Standards via Citizens Advice</p>
              </div>
            </section>
          </CardContent>
        </Card>
      </div>
    </div>
  )
}

export default TermsOfService